export const serviceFeeType = {
  SET_SERVICE_FEE: "SET_SERVICE_FEE",
};
